import { ALCHEMIST_REACH, ALCHEMY, MAX_BREW_COUNT } from '../data/alchemy.js';
/**
 * Brewing at the alchemist (ADR 0026), pure: what he brews where he stands,
 * how many potions a bag's materials allow, and what it all costs. The
 * server applies it, the client previews it.
 */
/** The alchemist's two recipes in this biome: the light potion, then the strong one. */
export function recipesAt(biome) {
    const alchemy = ALCHEMY[biome];
    return [
        { potion: alchemy.light.id, ingredients: alchemy.recipes.light, gold: alchemy.gold.light },
        { potion: alchemy.strong.id, ingredients: alchemy.recipes.strong, gold: alchemy.gold.strong },
    ];
}
/** The recipe for this potion in this biome; a potion of another biome is not brewed here. */
export function recipeFor(biome, potion) {
    return recipesAt(biome).find((recipe) => recipe.potion === potion);
}
/**
 * How many potions the materials in hand make, and the purse pays for,
 * capped at one request's worth. `have` counts a template across all its
 * stacks.
 */
export function brewableCount(recipe, have, gold) {
    let count = MAX_BREW_COUNT;
    for (const ingredient of recipe.ingredients) {
        count = Math.min(count, Math.floor(have(ingredient.templateId) / ingredient.quantity));
    }
    if (recipe.gold > 0)
        count = Math.min(count, Math.floor(gold / recipe.gold));
    return Math.max(0, count);
}
/** Within `ALCHEMIST_REACH` tiles of one of these alchemists, diagonals included. */
export function withinAlchemistReach(at, alchemists) {
    return alchemists.some((alchemist) => Math.max(Math.abs(alchemist.x - at.x), Math.abs(alchemist.y - at.y)) <= ALCHEMIST_REACH);
}
//# sourceMappingURL=alchemy.js.map